import state from './moduleEnterpriseVesselState.js'
import mutations from './moduleEnterpriseVesselMutations.js'
import actions from './moduleEnterpriseVesselActions.js'
import getters from './moduleEnterpriseVesselGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
